import _ from "lodash";
import Utils from "./Utils";

export const n = (olang, options = { langCode: null, wrapper: "{}" }) => {
  const { langCode, wrapper } = Object.assign(
    {},
    { langCode: null, wrapper: "{}" },
    options
  );

  const store = require("../app/store").default;

  const { language } = store.getState();
  const { language: lang } = language || {};

  olang = Utils.parseJSON(olang);
  if (!olang || _.isEmpty(olang)) return ``;

  const l = !langCode ? olang[lang] : olang[langCode];

  if (l) return l;

  let n = "";
  const w = wrapper.length > 1 ? wrapper.split("") : [wrapper, wrapper];
  const wone = w[0];
  const wtwo = w[1];

  Object.entries(olang).map(([key, value]) => {
    if (!value) return;

    n = `${wone}${value}${wtwo}`;
    // n = `[${value}]`;
  });

  return n;
};
